import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'rx-avatar',
  imports: [CommonModule],
  templateUrl: './rx-avatar.component.html',
  styleUrl: './rx-avatar.component.scss',
})
export class RxAvatarComponent {
  @Input() name: string = '';
  @Input() src: string | null = null;
  @Input() size: number = 50;

  get initials(): string {
    const names = this.name.split(' ');
    return names
      .map((n) => n.charAt(0).toUpperCase())
      .join('')
      .slice(0, 2);
  }

  get avatarStyle(): { [key: string]: string } {
    return {
      width: `${this.size}px`,
      height: `${this.size}px`,
      fontSize: `${this.size / 2.5}px`,
      lineHeight: `${this.size}px`,
    };
  }
}
